import React, { useState, useEffect } from "react";
import "./styles/styles.css";
import "../../styles/global.css";
import AccreditationInput from "../../components/AccreditationInput/AccreditationInput";
import { eventsTableOptionsFirst } from "../../constants/tables";
import TableFirst from "../../components/TableFirst/TableFirst";
import { apiRoutes } from "../../utils/apiRoutes";
import { fetchData } from "../../utils/methods";
import { addFieldToObjects } from "../../utils/addFieldToObjects";
import { useNavigate } from "react-router-dom";
import { useAlert } from "../../utils/AlertContext";
import { sortData } from "../../utils/sortData";
import { sortByCreatedAtIfExists } from "../../utils/sortByCreatedAtIfExists";
import { formatDateBg, formatDateTimeBg, eventDaysBg } from "../../utils/belgradeTime";

const EventsPageFirst = ({ t }) => {
  const [searchValue, setSearchValue] = useState("");
  const [events, setEvents] = useState([]);
  const [debouncedSearchValue, setDebouncedSearchValue] = useState("");
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [dataLength, setDataLength] = useState(0);
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const [sortField, setSortField] = useState(null);
  const [sortDirection, setSortDirection] = useState("asc");

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setIsLoadingData(true);

        const result = await fetchData(
          `${apiRoutes.getEvents}`,
          showAlert,
          navigate,
          t
        );
        if (!result) return;

        let dataLength = 0;
        for (const [key, value] of result.headers.entries()) {
          if (key === "x-total-count") {
            dataLength = Number(value);
          }
        }

        console.log(result.data, dataLength);
        setDataLength(dataLength);
        const sortedEvents = sortByCreatedAtIfExists(result.data);
        setEvents((prevEvents) => [...prevEvents, ...sortedEvents]);
      } catch (err) {
        console.error("Error fetching events:", err);
      } finally {
        setIsLoadingData(false);
      }
    };

    fetchEvents();
  }, []);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchValue(searchValue);
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);

  const filteredEvents = events?.filter((event) => {
    const fullName = `${event.naziv} ${formatDateBg(event.trajanje_do)}. ${formatDateBg(event.trajanje_od)}. ${event.lokacija}`.toLowerCase();
    return fullName.includes(debouncedSearchValue.toLowerCase());
  });

  const mappedEvents = filteredEvents.map((event) => {
    const mappedEvent = {
      id: event.id,
      slug: event.slug,
      className: "first-events",
      // Not one of eventsTableOptionsFirst's columns (trajanje_do isn't
      // shown on desktop) — added directly so the mobile compact row can
      // render a start-to-end date range instead of the duration in days.
      trajanje_do: formatDateTimeBg(event.trajanje_do),
    };
    eventsTableOptionsFirst(t).forEach((option) => {
      if (option.name === "trajanje") {
        mappedEvent[option.name] = eventDaysBg(event.trajanje_od, event.trajanje_do);
      } else if (option.name === "procesuirano_obradjeno") {
        mappedEvent[
          option.name
        ] = `${event.totalObradjeno} / ${event.totalOsobe}`;
      } else if (option.name === "name") {
        mappedEvent[option.name] = event.name;
      } else if (
        option.name === "trajanje_od" ||
        option.name === "trajanje_do"
      ) {
        mappedEvent[option.name] = formatDateTimeBg(event[option.name]);
      } else {
        const fieldName = option.name.toLowerCase();
        mappedEvent[option.name] = event[fieldName] || "";
      }
    });
    return mappedEvent;
  });

  const tableHeader = addFieldToObjects(
    eventsTableOptionsFirst(t),
    "class",
    "first-events"
  );

  const handleSortChange = (field, direction) => {
    setSortField(field);
    setSortDirection(direction);
  };

  return (
    <div className="flex-direction-column gap-12 width-100">
      <div className="flex-direction-column gap-48 title-search">
        <div className="flex-direction-row justify-between width-100 title">
          <h2
            className="font-36 inria-sans-300"
            style={{ color: "var(--Neutral-dark)", flexShrink: 0 }}
          >
            {t("EVENTS_TITLE")}
          </h2>
        </div>
        <div className="flex-direction-row gap-24 justify-between width-100 page-search">
          <AccreditationInput
            type="search"
            placeholder={t("SEARCH_PLACEHOLDER")}
            setInputValue={(value) => setSearchValue(value)}
            value={searchValue}
          />
        </div>
      </div>
      <TableFirst
        options={tableHeader}
        data={sortData(mappedEvents, sortField, sortDirection)}
        t={t}
        isLoadingData={isLoadingData}
        query={debouncedSearchValue}
        sortField={sortField}
        sortDirection={sortDirection}
        onSortChange={handleSortChange}
      />
    </div>
  );
};

export default EventsPageFirst;
